/**
 * The ixValidationButton directive can be used to display a button which is disabled if the given form is invalid.
 * Additionally it displays a tooltip with all fields which have to be filled with data to enable the button.
 *
 * @params {action&}               a function with parameters which will be called after the form is valid and the user clicked the button
 * @params {form=}                 the form which contains the required inputs
 * @params {disableExpression=?}   a optional object with a value and a error message which will be displayed if the value resolves to false
 * @params {clazz=?}               a optional string of css classes to style the button
 *
 * @usage
 * <ix-validation-button action="save(data)"
 *                       form="dialogData"
 *                       disable-expression="{value: var1 != var2, error: 'Please check your input für var1 and var2'}"
 *                       clazz="'md-accent full-width'">
 *                       {{::trns.save}}
 * </ix-validation-button>
 *
 */
angular.module('impactx.validationbutton').directive('ixValidationButton', function() {
    return {
        restrict: 'E',
        scope: {
            action: "&",
            form: "=",
            disableExpression: "=?",
            disableExpressions: "=?",
            clazz: "=?",
            direction: "@?",
            disabled: "=",
            tooltipDirectionTop: "=?",
            ignoreFields: "=?"
        },
        templateUrl: 'shared/savebutton/templates/validationbutton.html',
        controller: 'ValidationButtonCtrl',
        controllerAs: 'validationButtonCtrl',
        transclude: true
    };
});